import { Table } from "reactstrap";
import { Description, LineTotal, Qty, Rate } from "../../../../../constants";
import InvoiceOrderBody from "./InvoiceOrderBody";

// This component displays the order details, including description, rate, quantity, and line total.
const InvoiceOrder = () => {
  return (
    <td>
      <Table className="order-details">
        <thead>
          <tr >
            <th >
              <span>{Description}</span>
            </th>
            <th> 
              <span>{Rate}</span>
            </th>
            <th>
              <span>{Qty}</span>
            </th>
            <th>
              <span>{LineTotal}</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <InvoiceOrderBody />
        </tbody>
      </Table>
    </td>
  );
};

export default InvoiceOrder;
